import { ref } from 'vue'
import axios from 'axios'
import { useCoreUserStore } from '@Common/stores/CoreStore'
import { getLocalValue } from '@Common/utils/storage'


export function checkAuthentication() {
  const coreUser = useCoreUserStore()
  const authenticated = ref(false)

  if (getLocalValue('at')) {
    axios.defaults.headers.common['Authorization'] = `Token ${getLocalValue('at')}`

    return coreUser.checkToken().then(
      res => {
        authenticated.value = true
        return authenticated.value
      },
      err => {
        console.error(err)
        return authenticated.value
      }
    )
  } else {
    return Promise.resolve(authenticated.value)
  }
}
